import React from 'react';
import { scrollToSection } from '../../utils/pageScroll';
import styles from './scrollbar.module.css';

/** Секции главной по порядку: id элемента и подпись для скринридера.
 *  Секции, которых сейчас нет на странице (например FAQ без вопросов), пропускаются. */
const SECTIONS: { id: string; label: string }[] = [
  { id: 'main',            label: 'Начало' },
  { id: 'advantages',      label: 'Преимущества' },
  { id: 'slidercontainer', label: 'Роли' },
  { id: 'howtoinstall',    label: 'Как начать играть' },
  { id: 'latestnews',      label: 'Последние новости' },
  { id: 'faq',             label: 'Частые вопросы' },
  { id: 'community',       label: 'Мы на связи' },
];

const Scrollbar: React.FC = () => {
  const [present, setPresent] = React.useState<string[]>(SECTIONS.map(s => s.id));
  const [active, setActive] = React.useState('main');

  // useLayoutEffect: точки считаются до первой отрисовки, без мелькания
  React.useLayoutEffect(() => {
    // Активная точка — секция, через которую проходит середина экрана.
    // Прокручивается не window, а контейнер приложения: слушаем scroll в фазе захвата
    const update = () => {
      const ids = SECTIONS.map(s => s.id).filter(id => document.getElementById(id));
      setPresent(prev => (prev.join() === ids.join() ? prev : ids));
      const mid = window.innerHeight / 2;
      let current = ids[0] ?? 'main';
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= mid) current = id;
      }
      setActive(current);
    };
    update();
    document.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    // Новости и FAQ догружаются после монтирования — пересчитываем сразу,
    // как только их экран появился в разметке
    const host = document.getElementById('main')?.parentElement;
    const mo = host ? new MutationObserver(update) : null;
    if (host && mo) mo.observe(host, { childList: true });
    return () => {
      document.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
      mo?.disconnect();
    };
  }, []);

  const scrollMe = (target: string) => {
    scrollToSection(target);
  }

  return (
    <ul className={styles.ul}>
      {SECTIONS.filter(s => present.includes(s.id)).map(s => (
        <li key={s.id} className={`${styles.li} ${active === s.id ? styles.li_active : ""}`}>
          <button
            type="button"
            aria-label={s.label}
            aria-current={active === s.id ? 'true' : undefined}
            onClick={() => {scrollMe(s.id)}}
            className={styles.button}
          />
        </li>
      ))}
    </ul>
  );
}

export default Scrollbar;
